/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/

import { asMessageRenderer } from '@post-office/placement-common/utils/message-renderer';
import ccFlywheelFeatureDiscovery from '@post-office/team-export--cc-flywheel-feature-discovery/placements/in-app/confluence-home-banner/render';
import growth from '@post-office/team-export--growth/placements/in-app/confluence-home-banner/render';
import postOfficeTemplate from '@post-office/team-export--post-office-template/placements/in-app/confluence-home-banner/render';
import testMessages from '@post-office/team-export--test-messages/placements/in-app/confluence-home-banner/render';

export const renderer = { ...ccFlywheelFeatureDiscovery, ...growth, ...postOfficeTemplate, ...testMessages };

export const { initializeMessageRenderer, MessageRenderer } = asMessageRenderer(renderer);
